module.exports = __webpack_public_path__ + "static/img/ecaray_about_introduction_honor27.06fb17af.png";